import {event} from "d3-selection";

export function nopropagation() {
  event.stopImmediatePropagation();
}

export default function() {
  event.preventDefault();
  event.stopImmediatePropagation();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-drag/src/noevent.js
// module id = ./node_modules/d3-drag/src/noevent.js
// module chunks = 53